import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import sessionIcons from '../assets/SessionIcons';
import './Sessions.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ClipLoader from 'react-spinners/ClipLoader';
import CONFIG from '../config.js';

const Sessions = () => {
    const { user, fetchData, setFetchData, isAdmin, adminSelectedUser } = useContext(AuthContext);
    let userInfo = user;
    if (isAdmin) {
        userInfo = adminSelectedUser;
    }
    const formatDate = (date) => {

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    const navigate = useNavigate();
    const [sessionData, setSessionData] = useState();
    const [showSessions, setShowSessions] = useState(false);
    const [loading, setLoading] = useState(true);
    let currentDate = new Date();
    const [endDate, setEndDate] = useState(formatDate(currentDate));
    currentDate.setDate(currentDate.getDate() - 90);
    const [startDate, setStartDate] = useState(formatDate(currentDate.toDateString()));
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const url = CONFIG.createUrl();

    const config = {headers: CONFIG.HEADERS};

    const fetchSessionData = async () => {
        try {
            const response = await axios.get(`${url}polar/sessions/date-range?uuid=${userInfo.uuid}&start_date=${startDate}&end_date=${endDate}`, config);
            setSessionData(response.data.data);
            if (response.data.data.length) {
                setShowSessions(true);
            } else {
                setShowSessions(false);
            }
            setFetchData(prev => ({ ...prev, sessionsData: response.data.data, sessionsStartDate: startDate, sessionsEndDate: endDate }));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userInfo?.email) {
            if (!fetchData.sessionsData) {
                fetchSessionData();
            } else {
                if(fetchData.sessionsData.length > 0) {
                    setShowSessions(true);
                } else {
                    setShowSessions(false);
                }
                setStartDate(fetchData.sessionsStartDate);
                setEndDate(fetchData.sessionsEndDate);
                setSessionData(fetchData.sessionsData);
                setLoading(false);
            }
        }
    }, [userInfo?.email]);

    const validateDate = () => {
        return (startDate && endDate && (new Date(startDate) < new Date(endDate)));
    }

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
        if (validateDate()) {
            setShowErrorMsg(false);
        }
    }

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
        if (validateDate()) {
            setShowErrorMsg(false);
        }
    }

    const generateChart = () => {
        if (validateDate()) {
            setShowErrorMsg(false);
            setLoading(true);
            fetchSessionData();
        } else {
            setShowErrorMsg(true);
        }
    }

    function renderSessionDate(dateString) {
        const daysOfWeek = ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // Extract year, month, day
        let [year, month, day] = dateString.split("-").map(Number);

        // Adjust Zeller’s month and year (Jan & Feb are treated as months 13 & 14 of the previous year)
        let adjustedMonth = month;
        let adjustedYear = year;
        
        if (month < 3) {
            adjustedMonth += 12;
            adjustedYear -= 1;
        }

        // Zeller's Congruence Formula
        let K = adjustedYear % 100;
        let J = Math.floor(adjustedYear / 100);
        let h = (day + Math.floor(13 * (adjustedMonth + 1) / 5) + K + Math.floor(K / 4) + Math.floor(J / 4) + 5 * J) % 7;

        // Convert to readable format
        let dayOfWeek = daysOfWeek[h];
        let monthName = months[month - 1]; // Use the original month index for display

        return (<div className="session-date">{dayOfWeek},&nbsp;<span>{monthName} {day}</span></div>);
        return `${dayOfWeek}, ${monthName} ${day}`;
    }

    const goToSessionAnalysis = (uid) => {
        // Pass data via the state parameter
        navigate('/sessionAnalysis', { state: { identifier: uid, userUuid: userInfo.uuid } });
    };

    return (
        <div className="container">
            <div className="main-content">
                <section className="card">
                    <div className="sessions-container-wrapper">
                        <div className="sessions-container">
                            <h2>Sessions</h2>
                            <div className="filter-container">
                                <div>
                                    <label className="input-label" htmlFor="startDate">Start Date:</label>
                                    <input className="date-input" type="date" id="startDate" name="startDate" value={startDate} onChange={handleStartDateChange}></input>
                                </div>
                                <div>
                                    <label className="input-label" htmlFor="endDate">End Date:</label>
                                    <input className="date-input" type="date" id="endDate" name="endDate" value={endDate} onChange={handleEndDateChange}></input>
                                </div>
                                <div style={{ position: 'relative' }}>
                                    <button className="generate-button" onClick={generateChart}>Generate</button>
                                    {showErrorMsg &&
                                        <div className="error-msg">Enter valid dates to generate results.</div>
                                    }
                                </div>
                            </div>
                            {!loading && !showSessions && (!sessionData || sessionData.length === 0) &&
                                <div>No Sessions Recorded!</div>
                            }
                            {!loading && showSessions && sessionData.slice().sort((a, b) => new Date(b.date) - new Date(a.date)).map((data, index) => (
                                <div key={`${data.date}-${index}`} className="session-date-container">
                                    {renderSessionDate(data.date)}
                                    <div className="session-list">
                                        {data.sessions.slice().sort((a, b) => b.time.localeCompare(a.time)).map((item, index) => (
                                            <div key={`${data.date}-${item.position}-${index}`} className="session-list-container">
                                                <div className="session-list-item">
                                                    <div className="session-data"><div><b>Time:</b></div><div className="session-data-value">{item.time}</div></div>
                                                    <div className="session-data"><div><b>Duration:</b></div><div className="session-data-value">{item.duration}</div></div>
                                                    <div className="session-data"><div><b>HRV:</b></div><div className="session-data-value">{item.rmssd.toFixed(2)}</div></div>
                                                    <div className="session-data"><div><b>HR:</b></div><div className="session-data-value">{item.mean_hr.toFixed(2)}</div></div>
                                                    <div className="session-data"><div><b>LF HF Ratio:</b></div><div className="session-data-value">{item.lf_hf.toFixed(2)}</div></div>
                                                </div>
                                                <button className="chevron-right-button" onClick={() => goToSessionAnalysis(item.identifier)}><i className="fa-solid fa-chevron-right"></i></button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {loading &&
                            <div className="spinner-container">
                                <ClipLoader color={"#123abc"} loading={loading} size={50} />
                            </div>
                        }
                        <div className="notes-column" title="Coming Soon in v2">
                            <div><b>Generate Session Notes</b></div>
                            <div className="session-notes-container">
                                <div className="microphone-icon-container">
                                    <div className="microphone-icon"></div>
                                </div>
                                <div>
                                    <div className="notes-text-header"><b>Record Audio</b></div>
                                    <div className="notes-text">Use during live sessions</div>
                                </div>
                            </div>
                            <div className="session-notes-container">
                                <div className="microphone-icon-container">
                                    <div className="microphone-loud-icon"></div>
                                </div>
                                <div>
                                    <div className="notes-text-header"><b>Dictate Notes</b></div>
                                    <div className="notes-text">Turn client visits into notes</div>
                                </div>
                            </div>
                            <div className="session-notes-container">
                                <div className="microphone-icon-container">
                                    <div className="microphone-upload-icon"></div>
                                </div>
                                <div>
                                    <div className="notes-text-header"><b>Upload Recording</b></div>
                                    <div className="notes-text">Convert audio into notes</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Sessions;